import type { IconToken } from '../icons/index';
export interface DecorDef {
  id: string;
  name: string;
  icon: IconToken;
  price: number;
  /** Redneck Rating points while owned. */
  points: number;
  desc: string;
  /** False for decor you can only earn (e.g. adopting a possum). */
  buyable: boolean;
}

export const DECOR: readonly DecorDef[] = [
  {
    id: 'tires',
    name: 'Painted Tire Planter',
    icon: ':tire-planter:',
    price: 5,
    points: 2,
    buyable: true,
    desc: 'Upcycling before it was cool.',
  },
  {
    id: 'clothesline',
    name: 'Clothesline (Unmentionables Incl.)',
    icon: ':clothesline:',
    price: 8,
    points: 2,
    buyable: true,
    desc: 'Let the whole park know your business.',
  },
  {
    id: 'lll',
    name: '"Live Laugh Love" Sign',
    icon: ':lll-sign:',
    price: 10,
    points: 2,
    buyable: true,
    desc: 'Hang it next to the door you get evicted from.',
  },
  {
    id: 'flamingos',
    name: 'Pink Flamingo Pair',
    icon: ':flamingo:',
    price: 12,
    points: 3,
    buyable: true,
    desc: 'Classy AND trashy. The perfect balance.',
  },
  {
    id: 'goose',
    name: 'Concrete Porch Goose',
    icon: ':porch-goose:',
    price: 14,
    points: 3,
    buyable: true,
    desc: 'Comes with a raincoat. She has a different outfit every day.',
  },
  {
    id: 'gnomes',
    name: 'Gnome Militia (3)',
    icon: ':gnome:',
    price: 15,
    points: 3,
    buyable: true,
    desc: 'They guard the lawn. Mostly from mowing.',
  },
  {
    id: 'zapper',
    name: 'Bug Zapper',
    icon: ':bug-zapper:',
    price: 15,
    points: 2,
    buyable: true,
    desc: 'Free nightly entertainment. ZZZAP.',
  },
  {
    id: 'lights',
    name: 'Christmas Lights (Year-Round)',
    icon: ':xmas-lights:',
    price: 18,
    points: 4,
    buyable: true,
    desc: "It's Christmas somewhere. Specifically here. Always.",
  },
  {
    id: 'truckNutz',
    name: 'Truck Nutz',
    icon: ':peanuts:',
    price: 20,
    points: 5,
    buyable: true,
    desc: 'For the Camaro. She deserves them.',
  },
  {
    id: 'kiddiePool',
    name: 'Kiddie Pool',
    icon: ':kiddie-pool:',
    price: 20,
    points: 3,
    buyable: true,
    desc: 'Adult-sized feet, kid-sized dreams.',
  },
  {
    id: 'flag',
    name: 'Giant American Flag',
    icon: ':us-flag:',
    price: 25,
    points: 4,
    buyable: true,
    desc: 'Visible from space. Or at least from the highway.',
  },
  {
    id: 'dish',
    name: 'Satellite Dish (No Subscription)',
    icon: ':satellite-dish:',
    price: 30,
    points: 4,
    buyable: true,
    desc: "Gets 400 channels. You'll watch the same three.",
  },
  {
    id: 'recliner',
    name: 'Outdoor Recliner',
    icon: ':recliner:',
    price: 40,
    points: 4,
    buyable: true,
    desc: 'Indoor furniture, outdoor lifestyle.',
  },
  {
    id: 'smoker',
    name: 'Oil Drum Smoker',
    icon: ':smoker:',
    price: 45,
    points: 5,
    buyable: true,
    desc: 'Smoked dogs hit different. +60 Hunger.',
  },
  {
    id: 'tub',
    name: 'Clawfoot Tub "Hot Tub"',
    icon: ':clawfoot-tub:',
    price: 60,
    points: 6,
    buyable: true,
    desc: 'Garden hose sold separately. Heated by the sun and hope.',
  },
  {
    id: 'gorilla',
    name: 'Inflatable Gorilla',
    icon: ':inflatable-gorilla:',
    price: 70,
    points: 6,
    buyable: true,
    desc: 'Repossessed from a used car lot. Now he lives with you.',
  },
  {
    id: 'trampoline',
    name: 'Rusty Trampoline',
    icon: ':trampoline:',
    price: 90,
    points: 8,
    buyable: true,
    desc: 'Unlocks "Hold My Beer" stunts. Viral fame awaits.',
  },
  {
    id: 'pool',
    name: 'Above-Ground Pool',
    icon: ':above-ground-pool:',
    price: 180,
    points: 12,
    buyable: true,
    desc: 'Lucky Acres Country Club. Members: you.',
  },
  {
    id: 'bigTv',
    name: '75" Big Screen TV',
    icon: ':big-tv:',
    price: 400,
    points: 10,
    buyable: true,
    desc: 'Bigger than your bathroom. TV rests you twice as much.',
  },
  {
    id: 'possum',
    name: 'Kevin (Pet Possum)',
    icon: ':possum:',
    price: 0,
    points: 6,
    buyable: false,
    desc: 'Plays dead when stressed. Relatable.',
  },
];

const BY_ID = new Map(DECOR.map((d) => [d.id, d]));

export function decorDef(id: string): DecorDef | undefined {
  return BY_ID.get(id);
}

export function decorPoints(owned: readonly string[]): number {
  let total = 0;
  for (const id of owned) total += BY_ID.get(id)?.points ?? 0;
  return total;
}
